import { SerializedStyles } from '@emotion/react'

import { TermosDeUsoHeadingSection } from '../../components/TermosDeUsoHeadingSection'

interface CompartilhamentoDeDadosSectionProps {
  listStyle: SerializedStyles
}

export const CompartilhamentoDeDadosSection = (props: CompartilhamentoDeDadosSectionProps) => {
  const { listStyle } = props

  return (
    <TermosDeUsoHeadingSection title='9. Compartilhamento de Dados' id='compartilhamento_de_dados'>
      <p>O Prontuário Eletrônico do Cidadão (PEC) do Sistema e-SUS APS faz os seguintes compartilhamentos:</p>
      <br />
      <ol type='I' css={listStyle}>
        <li>Dos dados do e-SUS APS com o Centralizador Nacional, do Datasus/Ministério da Saúde;</li>
        <li>
          Dos dados de atendimento individual com a RNDS;
          <ol type='a' css={listStyle}>
            <br />
            <li>
              Dados do cidadão: CPF, CNS, Subjetivo (descrição em texto livre), Observação (descrição em texto livre),
              Avaliação (descrição em texto livre), problema e condição identificada, diagnósticos CID e/ou CIAP2,
              observações dos CID e/ou CIAP2, altura (cm), circunferência abdominal (cm), DUM, idade gestacional,
              Resultados do M-CHAT-R/F, perímetro cefálico (cm), peso (kg), pressão arterial (mmHg), abortos, gestas
              prévias, tipo de aleitamento, grau de certeza das alergias/reações adversas, categoria do agente causador,
              criticidade, agente ou substância específica, manifestações, data, observações, recomendações da
              prescrição eletrônica, dose, intervalo, turno, frequência da dose, via de administração, forma
              farmacêutica, quantidade, início do tratamento, conclusão do tratamento, unidade de fornecimento.{' '}
            </li>
            <li>
              Também são enviados dados referentes à vacinação: Estratégia, Data da administração do imunobiológico,
              Imunobiológico, Fabricante, Lote, Dose, Via de administração, Local de aplicação, Estabelecimento de saúde
              (código CNES), Grupo de atendimento, Condição maternal, data de validade da vacina (transcrição de
              caderneta);
            </li>
            <li>Dados do profissional: CNS, CNES da lotação, CBO da lotação do profissional, Equipe da lotação.</li>
            <br />
          </ol>
        </li>
        <li>
          Dos seguintes dados com o paciente, via e-mail cadastrado, caso haja prescrição digital: Informações do
          estabelecimento de saúde onde foi realizado o atendimento: Estado, Município, Endereço, Telefone 1, Telefone
          2; Informações do prescritor: Nome, Conselho de classe, Estado emissor, Número de registro no conselho, CBO;
          Identificação do cidadão: Nome do cidadão, Nome social, CNS do cidadão, Endereço do cidadão; Medicamentos
          incluídos na prescrição, com as informações: Aplicação / Uso, Nome do medicamento, Recomendações, Posologia,
          Unidade, Quantidade; Data do atendimento, Data e hora da impressão do documento, Nome do profissional
          responsável pela impressão;
        </li>
        <li>
          Dos seguintes dados com o Serviço centralizado de documentos digitais, caso haja prescrição digital:
          Informações do prescritor: Nome, CPF, Conselho de classe, Estado emissor, Número de registro no conselho,
          Código e descrição do CBO; Identificação do cidadão: Nome do cidadão, Nome social, CPF, CNS, Nome da mãe, Data
          de Nascimento, Sexo, País de nascimento, Município de nascimento, UF do município de nascimento; Informações
          dos medicamentos incluídos na prescrição: Princípio Ativo, Unidade de Fornecimento, Concentração, Forma
          Farmacêutica, Posologia, Quantidade Receitada, Via de Administração, Uso Contínuo, Data de Início do
          Tratamento, Data de Fim do Tratamento, Duração do Tratamento, Dose, Tipo de Frequência, Frequência da Dose,
          Dose Única, Recomendação, Tipo de Receita; Informações da prescrição: Data do atendimento e Tipo de receita.
        </li>
        <li>
          Dos dados específicos e pertinentes os quais são definidos pelos profissionais de saúde usuários do Prontuário
          Eletrônico do Cidadão (PEC) do Sistema e-SUS APS, com outro profissional da saúde, no caso de videochamada.
        </li>
        <li>
          Dos seguintes dados com o paciente, via e-mail cadastrado, caso haja atestado digital: Informações do
          estabelecimento de saúde onde foi realizado o atendimento: Estado, Município, Endereço, Telefone 1, Telefone
          2; Informações do emissor: Nome, Conselho de classe, Estado emissor, Número de registro no conselho, CBO;
          Identificação do cidadão: Nome do cidadão, Nome social, CPF do cidadão, CNS do cidadão; Conteúdo do atestado,
          Data do atendimento, Data e hora da assinatura do documento, Nome do profissional responsável pela emissão.
        </li>
        <li>
          CPF das pessoas beneficiárias do Programa de Proteção e Promoção da Saúde e Dignidade Menstrual com a API da
          Farmácia Popular para validação e emissão do documento de autorização.
        </li>
        <li>
          Dos seguintes dados com o Serviço centralizado de documentos digitais, caso haja assinatura digital de um
          atestado digital: Informações do estabelecimento de saúde onde foi realizado o atendimento: Estado, Município,
          Endereço, Telefone 1, Telefone 2; Informações do emissor: Nome, Nome social, CPF do emissor, Conselho de
          classe, Estado emissor, Número de registro no conselho, CBO; Identificação do cidadão: Nome do cidadão, Nome
          social, CPF do cidadão, CNS do cidadão, Sexo do cidadão, País de nascimento, Município de nascimento, Estado
          de nascimento; Conteúdo do atestado, Data do atendimento, Data e hora da assinatura do documento, Nome do
          profissional responsável pela emissão.
        </li>
        <li>
          Dos seguintes dados com o Serviço centralizado de documentos digitais, caso haja assinatura digital de um
          registro de atendimento: Identificação do cidadão: Nome do cidadão, Nome social, CPF, CNS, Idade, Data de
          nascimento, Nome da mãe, Sexo, País de nascimento, Município de nascimento, Estado de nascimento; Informações
          do emissor: Nome, Nome social, CPF do emissor, Conselho de classe, Estado emissor, Número de registro no
          conselho, CBO; Informações incluídas na impressão do atendimento: Tipo de participação do atendimento, Local
          de atendimento, Subjetivo (descrição em texto livre), Motivo da consulta, Objetivo (descrição em texto livre),
          DUM, DPP, Antropometria, Sinais vitais, Glicemia, Vacinação em dia?, Resultados de exames, Aplicação,
          Transcrição de caderneta de imunobiológico, Aprazamento de imunobiológico, Grupo-alvo, Status da vacinação,
          Imunobiológico e dose, Viajante, Resultados de Exames de Síndrome neurológica por Zika / Microcefalia,
          Avaliação (descrição em texto livre), Problemas e/ou condições avaliados neste atendimento, Alergias e reações
          adversas, Plano (descrição em texto livre), Histórico do plano de cuidado, Intervenções e/ou procedimentos
          clínicos realizados, Classificação de risco/vulnerabilidade, Prescrição de medicamentos, Solicitação de
          Exames, Atestados, Orientações, Encaminhamentos, Tipo de atendimento, Atendimento compartilhado, Procedimentos
          administrativos, Ficha de Notificação de caso suspeito, Racionalidade em saúde, Conduta, Desfecho do
          atendimento, Data e Horário de finalização do atendimento, Profissional que realizou o atendimento, Escuta
          inicial/orientação?, Tipo de aleitamento materno (se criança), Gestante, Puérpera, Doenças transmissíveis,
          Rastreamento de problema/condição avaliada, Triagem neonatal, Ficou em observação?, Cidadão em observação,
          Status de desenvolvimento da criança, Pré-natal, Parto e Nascimento da criança, Alterações fenotípicas da
          criança, Fatores de risco da criança, Marcos de desenvolvimento da criança, Pré-natal, Parto e nascimento
          (atendimento da gestante), Data de atendimento, Unidade responsável e turno, Vigilância em Saúde Bucal,
          Necessidade de prótese inferior/superior, Possui aparelho, Possui contenção, Prótese total superior, Prótese
          total inferior, Evoluções odontológicas, Fornecimento, Índice de Vulnerabilidade Clínico-Funcional (IVCF-20),
          Data e Horário da assinatura do documento.
        </li>
      </ol>
      <br />
      <p>
        Demais compartilhamentos de dados, que são feitos de outras formas, utilizando dados do Prontuário Eletrônico do
        Cidadão (PEC) do Sistema e-SUS APS - mas que não são feitos pelo próprio Sistema como supramencionado - e
        principalmente quando os estados e municípios operarem qualquer tipo de compartilhamento de dados com outras
        entidades, organizações ou instituições públicas ou privadas devem seguir as diretrizes da ANPD.
      </p>
      <br />
      <p>
        Os dados de navegação coletados pela ferramenta de análise de tráfego (Umami) são processados e armazenados
        exclusivamente em infraestrutura própria do Laboratório Bridge, não sendo compartilhados com terceiros,
        incluindo provedores externos de analytics.
      </p>
    </TermosDeUsoHeadingSection>
  )
}
